export { TopMessagePage as default } from '@/components/pages/Company/TopMessage'
